<template>
    <div class="page">
        <div class="head-bj">
            <img src="../../assets/temp/phb.png" mode="widthFix" style="width:100%" />

            <div class="content">
                <div class="content-tent">
                    <div class="content-thead">
                        <div class="flex-1">
                            排名
                        </div>
                        <div class="flex-3">
                            用户名称
                        </div>
                        <div class="flex-1 align-c">
                            {{actions[actionsIndex].value=='score'?'总积分':'总人数'}}
                        </div>
                    </div>
                    <div class="content-tbody">
                        <div class="content-tbody-tr" v-for="(item,index) in list" :key="index">
                            <div class="content-tbody-td flex-1 td1">
                                <img src="https://o-yzx.bysjy.com.cn/integral/01.png?x-oss-process=style/w64-h64" style="width:30px;height:30px" v-if="index == 0" />
                                <img src="https://o-yzx.bysjy.com.cn/integral/02.png?x-oss-process=style/w64-h64" style="width:30px;height:30px" v-if="index == 1" />
                                <img src="https://o-yzx.bysjy.com.cn/integral/03.png?x-oss-process=style/w64-h64" style="width:30px;height:30px" v-if="index == 2" />
                                <span v-if="index >2" style="padding-left:5px">
                                {{item.position}}
                            </span>
                            </div>
                            <div class="content-tbody-td flex-3 td-two-img td2">
                                <img :src="item.photo?item.photo+'?x-oss-process=style/w128-h128':default_head" style="width:20px;height:20px;vertical-align: middle;" />
                                <div class="td-name">{{item.user_name}}</div>
                            </div>
                            <div class="content-tbody-td flex-1 align-c td3">
                                {{item.scores}}
                            </div>
                        </div>
                    </div>
                    <div class="content-my">
                        <div class="content-tbody-tr">
                            <div class="content-tbody-td flex-1 td1">
                                <img src="https://o-yzx.bysjy.com.cn/integral/01.png?x-oss-process=style/w64-h64" mode="aspectFit" style="width:30px;height:30px" v-if="my.rank == '01'" />
                                <img src="https://o-yzx.bysjy.com.cn/integral/02.png?x-oss-process=style/w64-h64" mode="aspectFit" style="width:30px;height:30px" v-else-if="my.rank == '02'" />
                                <img src="https://o-yzx.bysjy.com.cn/integral/03.png?x-oss-process=style/w64-h64" mode="aspectFit" style="width:30px;height:30px" v-else-if="my.rank == '03'" />
                                <span v-else style="padding-left:5px">
                                {{my.position?my.position:'暂无'}}
                            </span>
                            </div>
                            <div class="content-tbody-td flex-3 td-two-img td2">
                                <img :src="my.photo?my.photo+'?x-oss-process=style/w128-h128':default_head" style="width:20px;height:20px;vertical-align: middle;" />
                                <div class="td-name">{{my.user_name}}</div>
                            </div>
                            <div class="content-tbody-td flex-1 align-c td3">
                                {{my.scores?my.scores:'暂无'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="header">
            <div class="header-phb-qh" @click="handleOpen">
                {{actions[actionsIndex].name}}
                <span class="iconfont iconqiehuan"></span>
            </div>
            <van-popup v-model="visible" round position="bottom">
                <van-picker
                        show-toolbar
                        :columns="action"
                        @cancel="visible = false"
                        @confirm="onConfirm"
                />
            </van-popup>
            <div class="header-title">
                <div :class="'header-title-tl '+ (type=='本日'?'curr':'')" @click="bindSwitchType" data-type="本日">本日</div>
                <div :class="'header-title-tl '+ (type=='本周'?'curr':'')" @click="bindSwitchType" data-type="本周">本周</div>
                <div :class="'header-title-tl '+ (type=='本月'?'curr':'')" @click="bindSwitchType" data-type="本月">本月</div>
            </div>
        </div>
    </div>

</template>

<script>
    import { Picker,Popup } from 'vant';
    export default {
        name: "index",
        components:{
            [Picker.name]:Picker,
            [Popup.name]:Popup
        },
        data(){
            return {
                visible: false,
                default_head:require('../../assets/icon/default_head.png'),
                action:[
                    '积分排行榜','分享排行榜'
                ],
                actions: [
                    {
                        name: '积分排行榜',
                        value:'score'
                    },
                    {
                        name: '分享排行榜',
                        value:'user'
                    }
                ],
                actionsIndex:0,
                type:'本日',
                list:[],
                my:{}
            }
        },
        mounted(){
            this.util.hideOptionMenu();
            this.actionsIndex = this.util.getQueryStr('actionsIndex') || 0;
            this.bindList();
        },
        methods:{
            onConfirm(value,index) {
                this.actionsIndex = index;
                this.visible = false;
                this.bindList();
            },
            handleOpen:function () {
                this.visible=true;
            },
            bindSwitchType:function(e){
                this.type=e.target.dataset.type;
                this.bindList();
            },
            bindList:function () {
                var _self=this;
                var type = 'day';
                switch (_self.type) {
                    case '本周':
                        type='week';
                        break;
                    case '本月':
                        type='month';
                        break;
                }
                this.util.server.mini_scores.ranking({
                    data: {
                        rank_type:_self.actions[_self.actionsIndex].value,
                        type: type,
                        token:this.util.token
                    },
                    methods:'get',
                    callback: (res => {
                        if(res.code == this.util.CODE.USER_LOGIN_FAIL){
                            return this.util.PopupLoginTips(res.msg,true);
                        }
                        var data= res.data;

                        for (var i=0;i<=data.top;i++){
                            if(!data.lists[i]){
                                data.lists[i]={
                                    user_name:'暂无',
                                    scores:'暂无',
                                    position:i
                                };
                            }
                        }

                        _self.list = data.lists;
                        _self.my = data.user;
                    })
                });
            }
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .head-bj{
        position: absolute;
        top: 0;
        width: 100%;
        font-size: 0;
        z-index: -1;
    }
    .header{
        padding: 15px;
        position: relative;
    }
    .header .header-phb-qh{
        display: inline-block;
        font-size: 18px;
        font-weight:bold;
        color: #FFFFFF;
    }
    .header-phb-qh .iconfont{
        font-size: 14px;
    }
    .header-title{
        position: absolute;
        top: 50%;
        right: 5px;
        margin-top: -10px;
    }
    .header-title,.header-title-tl{
        display: inline-block;
    }
    .header-title-tl{
        margin: 0 5px;
        padding: 2px 10px;
        background-color: #fff;
        border-radius: 10px;
        font-size: 12px;
        font-weight: bold;
        color: #3A3A3A;
    }
    .header-title-tl.curr{
        color: #327CE9;
    }
    .content-tent{
        background-color: #ffffff;
        width: 100%;
        height: 100%;
        border-radius:4px;
    }
    .content{
        width: 100%;
        height: 474px;
        padding: 10px;
        box-sizing: border-box;
        position: absolute;
        top: 70%;
    }
    .content .content-thead{
        padding: 15px 25px;
        display: flex;
        font-weight: bold;
    }
    .content-tbody{
        height: 378px;
        overflow-y: auto;
    }
    .content-tbody-tr{
        padding: 0 25px;
        display: flex;
        background-color: #F9F8F9;
        align-items: center;
        height: 42px;
    }
    .content-tbody-tr:nth-child(even){
        background-color: #ffffff;
    }
    .flex-1{
        flex: 1;
    }
    .flex-3{
        flex: 3;
    }
    .align-c{
        text-align: center;
    }
    .content-tbody-td.td1{
        font-size:14px;
        font-weight:800;
        color: #DCDCDC;
    }
    .content-tbody-td.td2{
        font-size:13px;
        font-weight:bold;
    }
    .content-tbody-td.td3{
        font-size:14px;
        font-weight:800;
        color: #3A3A3A;
    }
    .content-tbody-td.td-two-img img{
        width:20px;
        height:20px;
        border-radius:10px;
        vertical-align: middle;
    }
    .td-name{
        display: inline-block;
        margin-left: 5px;
        vertical-align: middle;
    }
    .content-my{
        margin-bottom: 50px;
    }
    .content-my .content-tbody-tr{
        background-color: #ffffff;
    }
    .content-my .content-tbody-td,.content-my .td-name{
        color: #327CE9;
    }

</style>
